<smt-modal [(isActive)]="showDeleteWarning" [disableFooter]="false" [disableHeader]="true" 
    (acceptEvent)="confirmDelete()" (rejectEvent)="showDeleteWarning = false" 
    acceptText="Yes" acceptCssClass="button primary" rejectText="No" rejectCssClass="button cancel">
    <div role="body">
        Are you sure you want to delete these shift blocks?
    </div>
</smt-modal>
<div *ngIf="selectedGridConfiguration == acuityGrid" class="form-row three">
    <div *ngFor="let schedule of activeShiftSchedules" class="form-group staffing-acuity-buttons">
        <div class="staffing-acuity-bottom-height">
          <label>{{formatShiftBlockType(schedule.shiftBlockType)}}</label>
          <span *ngIf="!readOnly" class="icon-trash" (click)="inactivateShiftSchedule(schedule.shiftBlockType)"></span>
        </div>
        <div class="staffing-acuity-bottom-border">
          <label>{{formatShiftBlockHours(schedule)}}</label>
        </div>
        <div *ngIf="!schedule.isClosed">
            <button 
                type="button"
                [disabled]="!enableVariableBySchedule(schedule)"
                (click)="setGridTypeBySchedule(schedule, false, false)">
                <span [hidden]="!isStaffingGridCompleteBySchedule(schedule, false)" class="icon-checkmark complete"></span> 
                 Variable
            </button>
            <button 
                type="button"
                [disabled]="!enableFixedBySchedule(schedule)" 
                (click)="setGridTypeBySchedule(schedule, true, false)">
                <span [hidden]="!isStaffingGridCompleteBySchedule(schedule, true)" class="icon-checkmark complete"></span> 
                 Fixed
            </button>
        </div>
        <div class="closed" *ngIf="schedule.isClosed">
            Closed
        </div>
    </div>
</div>
<div *ngIf="selectedGridConfiguration == inpatientGrid" class="staffing-grid-buttons">    
    <button 
        type="button"
        [disabled]="!enableWeekdayVariable()"
        [hidden]="!showWeekdayVariable()"
        [ngClass]="'button' + (isWeekdayVariableSelected() ? ' active' : '')"
        (click)="setWeekdayVariableGridType()">
        <span [hidden]="!isWeekdayVariableStaffingGridComplete()" class="icon-checkmark complete"></span> 
        Weekday Variable
    </button>  
    <button 
        type="button"
        [disabled]="!enableWeekdayFixed()"
        [hidden]='!showWeekdayFixed()'
        [ngClass]="'button' + (isWeekdayFixedSelected() ? ' active' : '')"
        (click)="setWeekdayFixedGridType()">
        <span [hidden]="!isWeekdayFixedStaffingGridComplete()" class="icon-checkmark complete"></span> 
        Weekday Fixed
    </button>      
    <button 
        type="button"
        [disabled]="!enableWeekendVariable()"
        [hidden]='!showWeekendVariable()'
        [ngClass]="'button' + (isWeekendVariableSelected() ? ' active' : '')"
        (click)="setWeekendVariableGridType()">
        <span [hidden]="!isWeekendVariableStaffingGridComplete()" class="icon-checkmark complete"></span>
        Weekend Variable
    </button>
    <button 
        type="button"
        [disabled]="!enableWeekendFixed()"
        [hidden]='!showWeekendFixed()'
        [ngClass]="'button' + (isWeekendFixedSelected() ? ' active' : '')"
        (click)="setWeekendFixedGridType()">
        <span [hidden]="!isWeekendFixedStaffingGridComplete()" class="icon-checkmark complete"></span> 
        Weekend Fixed
    </button>        
</div>
<div *ngIf="selectedGridConfiguration == totalUosGrid" class="form-row three">
    <div *ngFor="let schedule of activeShiftSchedules" class="form-group staffing-acuity-buttons">
        <div class="staffing-acuity-bottom-height">
          <label>{{formatShiftBlockType(schedule.shiftBlockType)}}</label>
          <span *ngIf="!readOnly" class="icon-trash" (click)="inactivateShiftSchedule(schedule.shiftBlockType)"></span>
        </div>
        <div class="staffing-acuity-bottom-border">
          <label>{{formatShiftBlockHours(schedule)}}</label>
        </div>
        <div *ngIf="!schedule.isClosed">
            <button 
                type="button"
                [disabled]="!enableVariableBySchedule(schedule)"
                (click)="setGridTypeBySchedule(schedule, false, false)">
                <span [hidden]="!isStaffingGridCompleteBySchedule(schedule, false)" class="icon-checkmark complete"></span> 
                 Variable
            </button>
            <button 
                type="button"
                [disabled]="!enableFixedBySchedule(schedule)" 
                (click)="setGridTypeBySchedule(schedule, true, false)">
                <span [hidden]="!isStaffingGridCompleteBySchedule(schedule, true)" class="icon-checkmark complete"></span> 
                 Fixed
            </button>
            <button 
                type="button"
                (click)="setGridTypeBySchedule(schedule, false, true)"
                [hidden]="!showAddOns()">
                <span [hidden]="!isAddOnsStaffingGridComplete(schedule)" class="icon-checkmark complete"></span> 
                 Add Ons
            </button>
        </div>
        <div class="closed" *ngIf="schedule.isClosed">
            Closed
        </div>
    </div>
</div>
